<template>
  <div>
    <PageAllow controller="ReturnBaskets" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('ProductionPlans.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="primary"
              class="elevation-1 ms-1"
              width="110px"
              href="/#/return-baskets/new/"
            >
              {{ $t("ReturnBasket.createBtn") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="code"
                  v-model="options.code"
                  @text="code = $event"
                  :label="$t('ReturnBasket.Fields.code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="shop_keyword"
                  v-model="options.shop_keyword"
                  @text="shopKeyword = $event"
                  :label="$consts.shopName()"
                />

              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrictsWithDescendants v-model="districtSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('ReturnBasket.status.title')"
                  :items="$consts.return_basket.status"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="mx-4 my-4">
        <v-data-table
          id="return_baskets_table"
          :headers="headers"
          class="elevation-2 pa-4 mt-4"
          :items="ReturnBaskets"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :footer-props="$t('$config.footer-props')"
          :loading="loading"
        >
          <!-- 合计 -->
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td>
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td>
              </td>
              <td>{{ totalReturnNum | formatTwoDot }}</td>
              <td>{{ $t("Global.money") }}{{ totalPrice | formatTwoDot }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("TableSum") }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("ReturnBasket.Fields.total_return_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ totalReturnNum | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("ReturnBasket.Fields.total_price") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}{{ totalPrice | formatTwoDot }}
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.shop="{ item }">
            {{ item.shop.shop_code + " / " + item.shop.shop_name }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | returnBasketStatusColor"
              :text-color="item.status | returnBasketStatusTextColor"
              >{{ item.status | returnBasketStatusText }}
            </v-chip>
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.total_price="{ item }">
            {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  :href="'/#/return-baskets/' + item.id"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("ReturnBasket.actions.detail") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("ReturnBasket.ObjectName")])
              }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import ReturnBaskets from "@/api/return_baskets";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  code: "",
  shop_ids: null,
  status: [1, 2],
  district_codes: null,
  shop_keyword: '',
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherDistrictsWithDescendants,
    SearcherStatus,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.returnOrderManagement"),
          disabled: false,
          replace: true,
          href: "/return-orders",
        },
        {
          text: i18n.t("Nav.returnBaskets"),
          disabled: true,
          href: "/return-baskets",
        },
      ];
      return items;
    },

    headers() {
      let headers = [
        {
          text: i18n.t("ReturnBasket.Fields.code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text:
            i18n.t("ReturnBasket.Fields.shop_code", [this.$consts.shopName()]) +
            "/" +
            i18n.t("ReturnBasket.Fields.shop", [this.$consts.shopName()]),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop",
        },
        {
          text: i18n.t("ReturnBasket.Fields.total_return_num"),
          align: "start",
          sortable: false,
          value: "total_return_num",
        },
        {
          text: i18n.t("ReturnBasket.Fields.total_price"),
          align: "start",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("ReturnBasket.Fields.status"),
          align: "start",
          value: "status",
        },
        {
          text: i18n.t("ReturnBasket.Fields.created"),
          align: "start",
          value: "created",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    ReturnBaskets: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("return-baskets-options")
        ? sessionStorage.getItem("return-baskets-options")
        : JSON.stringify(defaultOptions)
    ),
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    code: "",
    shopsSelected: null,
    districtSelected: null,
    loading: false,
    shopKeyword: '',
    totalPrice: 0,
    totalReturnNum: 0,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("return-baskets", ["shopsSelected", "districtSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.code = "";
      this.shopKeyword = "";
      this.shopsSelected = null;
      this.districtSelected = null;
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.code, this.$refs.shop_keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        code: this.code,
        shop_keyword: this.shopKeyword,
      });
    },
    getReturnBasketsFromAPI() {
      this.loading = true;
      ReturnBaskets.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.ReturnBaskets = response.data.return_baskets;
            this.totalPrice = response.data.total_price;
            this.totalReturnNum = response.data.total_return_num;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getReturnBasketsFromAPI();
        sessionStorage.setItem(
          "return-baskets-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((shop) => {
              return shop.id;
            })
          : [];
        sessionStorage.setItem(
          "return-baskets-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    districtSelected: {
      handler() {
        this.options.district_codes = this.districtSelected
          ? this.districtSelected.map((d) => {
              return d.code;
            })
          : [];
        sessionStorage.setItem(
          "return-baskets-districtSelected",
          JSON.stringify(this.districtSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>